import { queryOptions } from '@tanstack/react-query';
import type { GlobalAppointment, GlobalAppointmentsTotals } from '@erp/shared';
import { api, apiList } from '@/lib/api-client';

/** Apontamentos por página na folha de horas. */
export const TIMESHEET_PAGE_SIZE = 50;

export interface TimesheetFilters {
  start: string;
  end: string;
  user?: number;
}

export interface TimesheetParams extends TimesheetFilters {
  /** 1… */
  page: number;
}

/** Os filtros no formato da API — os MESMOS para a lista e para os totais. */
function timesheetQuery(f: TimesheetFilters) {
  return {
    start_date: f.start,
    end_date: f.end,
    user_ids: f.user !== undefined ? [f.user] : undefined,
  };
}

/** Uma página da folha de horas (GET /appointments, total no X-Total-Items). */
export function timesheetQueryOptions(params: TimesheetParams) {
  return queryOptions({
    queryKey: ['erp', 'appointments', 'timesheet', params],
    queryFn: async () => {
      const res = await apiList<GlobalAppointment>('/appointments', {
        query: {
          ...timesheetQuery(params),
          limit: TIMESHEET_PAGE_SIZE,
          offset: (params.page - 1) * TIMESHEET_PAGE_SIZE,
        },
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}

/**
 * Totais do período INTEIRO (GET /appointments/totals): a lista é paginada,
 * então somar no navegador daria o total da página. Sem a página na chave —
 * trocar de página não busca os totais de novo.
 */
export function timesheetTotalsQueryOptions(filters: TimesheetFilters) {
  return queryOptions({
    queryKey: ['erp', 'appointments', 'timesheet-totals', filters],
    queryFn: async () => {
      const res = await api<GlobalAppointmentsTotals>('/appointments/totals', {
        query: timesheetQuery(filters),
      });
      if (res.error) throw res.error;
      return res.data;
    },
  });
}
